export default __webpack_public_path__ + "static/media/white-delete.58a5d2d4.svg";